import type { AppLocale } from "@metaadsmanager/tk-master-contracts";
import { Label, ListBox, Select } from "@heroui/react";
import { Globe } from "@gravity-ui/icons";

import { useAppI18n } from "../../i18n/context";
import {
  fieldSelectPopoverClassName,
  fieldSelectPopoverPlacement,
} from "../../lib/ui/field-select-popover";

const localeOptions: {
  id: AppLocale;
  labelKey: "language.localeZh" | "language.localeEn";
}[] = [
  { id: "zh-CN", labelKey: "language.localeZh" },
  { id: "en-US", labelKey: "language.localeEn" },
];

/** 顶栏 / 认证页语言选择：HeroUI Select + globe（对齐 Figma lang chip）。 */
export function LanguageSwitcher() {
  const { locale, setLocale, t } = useAppI18n();

  const handleLocaleChange = (key: React.Key | null) => {
    if (!key || key === locale) return;
    const nextLocale = String(key) as AppLocale;
    if (nextLocale !== "zh-CN" && nextLocale !== "en-US") return;
    setLocale(nextLocale);
  };

  return (
    <Select
      aria-label={t("language.localeLabel")}
      className="language-switcher"
      onSelectionChange={handleLocaleChange}
      selectedKey={locale}
    >
      <Label className="sr-only">{t("language.localeLabel")}</Label>
      <Select.Trigger>
        <Globe width={24} height={24} aria-hidden className="language-switcher__globe" />
        <Select.Value />
        <Select.Indicator />
      </Select.Trigger>
      <Select.Popover
        className={fieldSelectPopoverClassName}
        placement={fieldSelectPopoverPlacement}
      >
        <ListBox>
          {localeOptions.map((option) => (
            <ListBox.Item
              id={option.id}
              key={option.id}
              textValue={t(option.labelKey)}
            >
              {t(option.labelKey)}
              <ListBox.ItemIndicator />
            </ListBox.Item>
          ))}
        </ListBox>
      </Select.Popover>
    </Select>
  );
}
